import { StyledInput, StyledInputProps } from './StyledInput';

export type { StyledInputProps };
export default StyledInput;
